module.exports = __webpack_public_path__ + "media/images/products/shop/4-76284b861508121113cfa9b859d71cbc.jpg";